// Rounded rectangle SVG path with a top-left notch of configurable width
export const LabelShapeSVG = ({
  width = 224,
  height = 70,
  arcRadius = 4,
  notchWidth = 64,
  stroke,
  strokeWidth = 0.42,
  strokeOpacity = 0.081,
  fillOpacity = 0.081,
  fill = "transparent",
  padding = 10,
  searchLogo=true
}) => {
  const notchDepth = notchWidth/5.333;
  // Adjusted width and height for the path to account for padding
  const paddedWidth = width - 2 * padding;
  const paddedHeight = height - 2 * padding;

  // Notch starts at top left, goes right by notchWidth, down by notchDepth, then continues
  const x0 = padding;
  const y0 = padding;
  const x1 = x0 + notchWidth;
  const y1 = y0;
  const x2 = x1;
  const y2 = y0 + notchDepth;
  const x3 = x0 + paddedWidth - arcRadius;
  const y3 = y0 + notchDepth;
  const x4 = x0 + paddedWidth;
  const y4 = y0 + notchDepth + arcRadius;
  const x5 = x0 + paddedWidth;
  const y5 = y0 + paddedHeight - arcRadius;
  const x6 = x0 + paddedWidth - arcRadius;
  const y6 = y0 + paddedHeight;
  const x7 = x0 + arcRadius;
  const y7 = y0 + paddedHeight;
  const x8 = x0;
  const y8 = y0 + paddedHeight - arcRadius;
  const x9 = x0;
  const y9 = y0 + arcRadius + notchDepth;

  const d = [
    `M ${x0 + arcRadius},${y0}`,
    `H ${x1 - arcRadius}`,
    `A ${arcRadius},${arcRadius} 0 0 1 ${x1},${y2 - arcRadius * 2}`,
    `V ${y2 - arcRadius}`,
    `A ${arcRadius},${arcRadius} 0 0 0 ${x1 + arcRadius},${y2}`,
    `H ${x3}`,
    `A ${arcRadius},${arcRadius} 0 0 1 ${x4},${y4}`,
    `V ${y5}`,
    `A ${arcRadius},${arcRadius} 0 0 1 ${x6},${y6}`,
    `H ${x7}`,
    `A ${arcRadius},${arcRadius} 0 0 1 ${x8},${y8}`,
    `V ${y9 - arcRadius * 3}`,
    `A ${arcRadius},${arcRadius} 0 0 1 ${x0 + arcRadius},${y0}`,
    `Z`
  ].join(" ");

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        transform={`translate(${padding + 6},${padding + notchDepth + 12}), scale(0.64)`} clipPath="url(#clip0_3821_3798)">
        {
        searchLogo && <path
          opacity={0.42}
          d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
          fill="currentColor"
        />
        }
      </g>

      <defs>
        <clipPath id="clip0_3821_3798">
          <rect width="24" height="24" fill="currentColor" />
        </clipPath>
      </defs>

      <path
        d={d}
        fill={fill}
        stroke={stroke || "currentColor"}
        strokeWidth={strokeWidth}
        opacity={strokeOpacity}
      />

      <rect
        mask="url(#shape1-cutout)"
        rx={arcRadius}
        x={0 + padding + arcRadius / 2}
        y={(padding + arcRadius / 2) * 2}
        width={width - padding * 2 - arcRadius}
        height={height - (padding * 2) - (padding + arcRadius) - 2}
        fill="currentColor"
        opacity={fillOpacity} strokeWidth={0} />
    </svg>
  );
}
